var _path, _ellipse, _ellipse2, _ellipse3, _g, _path2, _path3, _path4, _ellipse4, _ellipse5, _ellipse6, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCoffeeChat = function SvgCoffeeChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 194,
    viewBox: "0 0 272 194",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.713 33.6722C202.584 33.2179 202.406 32.7837 202.177 32.3717C198.006 24.8719 178.594 27.5315 158.818 38.312C140.868 48.097 128.789 61.209 129.83 69.1553L129.722 69.2118L129.865 69.3925C129.984 70.1119 130.215 70.7871 130.562 71.4115C131.233 72.6183 132.299 73.5621 133.698 74.2513L140.303 82.6246C151.658 97.0187 170.917 102.013 186.764 94.6726C196.614 90.1103 203.487 81.5646 206.313 71.5492L206.117 75.1062C206.968 74.1818 208.61 72.9846 210.597 71.5363C217.474 66.5232 228.479 58.5009 225.078 48.3685C219.504 31.7659 209.607 30.3037 202.713 33.6722ZM207.41 66.2381C218.595 59.8916 222.026 54.1493 218.081 45.9256C214.552 38.5701 207.864 39.1074 204.082 43.1402L205.995 49.4205C207.716 55.0703 208.137 60.7947 207.41 66.2381Z",
    fill: "#C8D9EB"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 33.4843,
    ry: 10.0877,
    transform: "matrix(0.855654 -0.467239 0.491344 0.880448 164.858 51.0558)",
    fill: "#C8D9EB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 33.4843,
    ry: 10.0877,
    transform: "matrix(0.855654 -0.467239 0.491344 0.880448 164.858 51.0558)",
    fill: "#1D6278",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 135,
    y: 33,
    width: 59,
    height: 37
  }, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 33.4811,
    ry: 10.1005,
    transform: "matrix(0.855469 -0.466997 0.491602 0.880277 164.858 51.0545)",
    fill: "#7EC2E4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 35.0023,
    ry: 10.1137,
    transform: "matrix(0.855304 -0.467214 0.49133 0.880377 166.572 56.0506)",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.738 67.0598C136.8 83.8192 155.922 76.6904 162.632 74.4028C193.39 54.0258 189.219 35.8022 185.448 37.491C181.677 39.1798 194.992 52.3391 164.814 69.4085C138.018 84.5653 146.479 67.7632 152.043 56.4687C152.916 53.016 152.677 50.3004 144.738 67.0598Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.393 65.2449C147.626 75.187 158.302 70.9836 164.443 67.42C184.467 54.4552 183.79 41.2495 183.641 38.3462L183.639 38.2998C183.495 35.4935 182.824 44.5492 175.919 51.8032C169.015 59.0572 164.443 67.42 164.3 64.6139C164.157 61.8079 153.409 63.8938 152.54 62.2739C151.67 60.654 155.001 48.6853 150.393 65.2449Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.533 60.8069C154.372 62.1417 156.771 63.2007 160.253 62.5503C163.735 61.8999 165.013 63.0024 165.013 63.0024C165.899 62.0313 170.675 57.333 173.671 53.2402C177.628 47.8341 177.717 43.1627 176.454 43.2386C174.977 43.3274 179.158 46.3343 172.815 52.0454C168.286 56.1241 166.652 58.5367 165.504 59.3375C164.357 60.1383 164.173 59.043 159.356 60.082C153.175 61.4149 157.456 55.0484 157.382 54.3637C157.308 53.679 154.733 59.1385 154.533 60.8069Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.226 57.7012C160.031 58.6036 164.214 57.3328 165.399 59.2419C166.403 55.6349 169.662 53.8881 171.872 49.7408C174.083 45.5936 171.655 46.25 168.909 48.0542C166.162 49.8585 167.017 51.0542 163.703 51.1035C160.388 51.1527 158.22 56.5732 159.226 57.7012Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.212 48.5963C161.534 49.6924 164.309 49.8754 165.906 49.8299C166.329 49.2575 167.68 47.6285 169.698 45.6915C171.716 43.7546 167.924 46.0554 165.776 47.4479C165.621 47.374 164.89 47.5003 163.212 48.5963Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.029 72.5028L164.413 61.8364L165.788 60.2158L163.029 72.5028Z",
    fill: "#F7EFE0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M147.551 64.7283C140.676 79.2418 157.236 73.0683 163.047 71.0872C189.682 53.4411 186.07 37.6597 182.805 39.1222C179.539 40.5847 191.07 51.9804 164.936 66.7623C141.731 79.8878 149.058 65.3375 153.876 55.5566C154.632 52.5666 154.425 50.2149 147.551 64.7283Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.448 63.1566C150.051 71.7663 159.297 68.1263 164.615 65.0402C181.955 53.813 181.369 42.377 181.24 39.8627L181.238 39.8226C181.114 37.3924 180.532 45.2344 174.553 51.5163C168.574 57.7982 164.615 65.0402 164.491 62.6102C164.367 60.1802 155.06 61.9866 154.307 60.5838C153.554 59.181 156.438 48.8163 152.448 63.1566Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.033 59.3134C155.894 60.4693 157.971 61.3864 160.986 60.8232C164.002 60.2599 165.108 61.2146 165.108 61.2146C165.876 60.3737 170.012 56.305 172.606 52.7608C176.033 48.0791 176.11 44.0338 175.017 44.0995C173.737 44.1764 177.358 46.7804 171.865 51.7261C167.942 55.2581 166.527 57.3475 165.534 58.0409C164.541 58.7344 164.381 57.7859 160.209 58.6856C154.857 59.8399 158.564 54.3266 158.5 53.7337C158.436 53.1407 156.206 57.8686 156.033 59.3134Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.097 56.6239C160.794 57.4054 164.416 56.3049 165.443 57.9582C166.312 54.8345 169.134 53.3218 171.048 49.7303C172.963 46.1389 170.861 46.7073 168.482 48.2698C166.103 49.8322 166.844 50.8677 163.974 50.9104C161.103 50.953 159.225 55.6471 160.097 56.6239Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.549 48.7392C162.096 49.6884 164.499 49.8468 165.882 49.8074C166.248 49.3118 167.418 47.9011 169.166 46.2237C170.913 44.5463 167.63 46.5388 165.77 47.7447C165.635 47.6807 165.002 47.79 163.549 48.7392Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.39 69.4419L164.589 60.2049L165.78 58.8015L163.39 69.4419Z",
    fill: "#F7EFE0"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.707 64.3087C126.014 61.3239 137.439 63.8931 148.105 57.0384L139.117 69.6646C133.415 68.9456 129.4 67.2935 127.707 64.3087Z",
    fill: "#CBAEA2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.098 67.4112C120.599 66.3182 115.814 64.6131 116.673 66.5365C117.748 68.9407 127.227 69.8199 123.098 67.4112Z",
    fill: "#CBAEA2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.3277 118.997C56.7263 120.552 57.6761 121.95 59.0922 123.174L66.2732 137.76C68.0972 141.465 70.5606 144.779 73.492 147.625C64.8906 153.216 58.9793 153.281 53.6265 147.217C46.4777 139.117 54.5434 131.327 62.412 132.908L56.6668 124.76C47.529 125.765 34.5308 138.243 53.0426 154.566C60.3093 160.974 70.8042 155.804 78.2359 151.547C87.5428 158.082 99.7845 160.732 111.314 157.866C127.359 153.878 137.545 140.266 135.92 124.981L134.438 111.041C136.01 108.747 136.612 106.43 136.045 104.219C133.804 95.4784 114.141 91.7007 92.128 95.7816C71.9307 99.5258 56.7717 108.584 56.1391 116.805L55.9722 116.837L56.1214 117.14C56.1034 117.765 56.1707 118.385 56.3277 118.997Z",
    fill: "#F8E0A5"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 32.2475,
    ry: 10.6599,
    transform: "matrix(-0.995291 0.195251 0.236419 0.948941 96.7713 109.964)",
    fill: "#F8E0A5"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 32.2475,
    ry: 10.6599,
    transform: "matrix(-0.995291 0.195251 0.236419 0.948941 96.7713 109.964)",
    fill: "#8E8741",
    fillOpacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 98,
    width: 65,
    height: 24
  }, _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 32.2307,
    ry: 10.6831,
    transform: "matrix(-0.995505 0.194758 0.23682 0.948673 96.7714 109.964)",
    fill: "#FDC73C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    rx: 33.6897,
    ry: 10.7151,
    transform: "matrix(-0.995361 0.195179 0.236274 0.948735 98.753 114.856)",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.725 110.267C139.012 117.862 120.564 123.64 114.24 125.822C78.3492 128.663 68.5734 113.08 72.4088 112.145C76.2443 111.211 76.0434 128.358 109.218 123.454C138.674 119.099 120.989 111.772 109.189 106.777C106.165 104.776 104.438 102.672 121.725 110.267Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.475 112.188C125.361 117.805 114.905 120.869 108.091 121.802C84.9364 123.869 76.1997 113.918 74.2789 111.731L74.2482 111.696C72.3912 109.582 79.1827 115.755 89.1089 117.058C99.035 118.361 108.091 121.802 106.235 119.688C104.378 117.574 113.406 112.935 112.889 111.265C112.371 109.594 101.673 102.833 116.475 112.188Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.461 111.343C111.505 112.218 110.554 114.357 107.646 115.878C104.739 117.399 104.608 118.928 104.608 118.928C103.306 118.732 96.6625 118.062 91.6958 116.813C85.1354 115.162 81.8138 111.829 82.7562 111.162C83.8591 110.381 83.0112 114.951 91.4653 115.458C97.5028 115.82 100.338 116.632 101.705 116.556C103.072 116.479 102.437 115.581 106.557 113.577C111.842 111.006 104.384 108.845 103.958 108.307C103.532 107.769 109.156 110.249 110.461 111.343Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.987 111.779C105.049 112.893 101.215 114.366 101.712 116.426C98.4881 114.388 94.973 114.988 90.5218 113.249C86.0707 111.511 88.239 110.597 91.4333 110.332C94.6276 110.068 94.8591 111.423 97.2291 109.562C99.5991 107.702 104.909 110.386 104.987 111.779Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8255 107.466C97.7727 107.3 95.9453 109.02 94.7881 109.9C94.0905 109.728 92.0018 109.321 89.2285 109.073C86.4552 108.825 90.7322 108.322 93.2174 108.101C93.2754 107.959 93.8782 107.632 95.8255 107.466Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.634 124.673L104.217 117.741L102.117 117.354L112.634 124.673Z",
    fill: "#F7EFE0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M118.172 110.165C133.143 116.742 117.167 121.745 111.69 123.635C80.6093 126.095 72.1436 112.601 75.4651 111.792C78.7865 110.982 78.6125 125.831 107.341 121.584C132.85 117.813 117.535 111.469 107.316 107.142C104.697 105.409 103.202 103.588 118.172 110.165Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.625 111.828C121.321 116.692 112.266 119.346 106.366 120.154C86.3137 121.944 78.7479 113.327 77.0845 111.433L77.0579 111.402C75.4498 109.571 81.3311 114.918 89.927 116.046C98.5229 117.174 106.366 120.154 104.758 118.323C103.15 116.492 110.968 112.476 110.52 111.029C110.072 109.582 100.808 103.727 113.625 111.828Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.418 111.096C109.322 111.854 108.498 113.707 105.98 115.024C103.463 116.341 103.349 117.665 103.349 117.665C102.222 117.496 96.4684 116.916 92.1673 115.833C86.4861 114.404 83.6096 111.518 84.4258 110.94C85.3808 110.264 84.6466 114.221 91.9677 114.66C97.1961 114.973 99.6509 115.677 100.835 115.611C102.019 115.545 101.469 114.767 105.037 113.031C109.613 110.805 103.155 108.933 102.786 108.467C102.417 108.002 107.287 110.149 108.418 111.096Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.677 111.474C103.731 112.439 100.411 113.714 100.841 115.499C98.0494 113.734 95.0053 114.253 91.1507 112.747C87.296 111.242 89.1738 110.451 91.94 110.221C94.7062 109.992 94.9067 111.166 96.959 109.555C99.0114 107.943 103.61 110.268 103.677 111.474Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7435 107.739C97.4298 107.595 95.8473 109.085 94.8452 109.847C94.241 109.698 92.4323 109.346 90.0306 109.131C87.629 108.916 91.3328 108.48 93.4849 108.289C93.5352 108.166 94.0572 107.883 95.7435 107.739Z",
    fill: "#F7EFE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.3 122.64L103.011 116.637L101.192 116.302L110.3 122.64Z",
    fill: "#F7EFE0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 45.2826,
    y1: 43.3581,
    x2: 27.5255,
    y2: 0.282988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBAEA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 43.5845,
    y1: 45.9362,
    x2: 23.4939,
    y2: 1.66082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A7771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBAEA2"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCoffeeChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/coffeeChat.4772365e.svg";
export { ForwardRef as ReactComponent };